export default __webpack_public_path__ + "static/media/doge.e66fad45.png";